export default {
    "help.title": "Centre d'aide & Questions Fréquentes (FAQ) - CitoyenPro",
    "help.seo_description": "Besoin d'aide ? Consultez notre Centre d'aide et notre FAQ pour des réponses rapides concernant l'examen de citoyenneté canadienne et nos abonnements.",
    "help.hero.title": "Comment pouvons-nous vous aider ?",
    "help.nav.back_home": "Retour à l'accueil",

    "help.categories.account.title": "Compte & Connexion",
    "help.categories.account.desc": "Problèmes de mot de passe, email de confirmation non reçu, paramètres de profil.",
    "help.categories.billing.title": "Facturation & Abonnement",
    "help.categories.billing.desc": "Changer de plan, annuler l'abonnement, factures, remboursements.",
    "help.categories.content.title": "Contenu & Cours",
    "help.categories.content.desc": "Questions sur le guide officiel, fonctionnement des quiz, examens blancs.",
    "help.categories.support.title": "Support Technique",
    "help.categories.support.desc": "Signaler un bug, problème d'affichage, application lente.",

    "help.faq.title": "Questions fréquentes",
    "help.faq.q1": "Comment réinitialiser mon mot de passe ?",
    "help.faq.a1": "Si vous avez oublié votre mot de passe, cliquez sur 'Mot de passe oublié' sur la page de connexion. Vous recevrez un email pour en créer un nouveau.",
    "help.faq.q2": "L'application fonctionne-t-elle hors ligne ?",
    "help.faq.a2": "Pour le moment, une connexion internet est requise pour les quiz interactifs. Cependant, les abonnés Standard et Premium peuvent télécharger les PDF pour réviser hors ligne.",
    "help.faq.q3": "Comment annuler mon abonnement ?",
    "help.faq.a3": "Vous pouvez annuler à tout moment depuis votre Tableau de bord > Mon Abonnement. L'accès reste actif jusqu'à la fin de la période payée.",
    "help.faq.q4": "Puis-je lire le livre officiel depuis l'application ?",
    "help.faq.a4": "Oui ! Nous avons intégré un lecteur complet du livre 'Découvrir le Canada' au format EPUB. Cette fonctionnalité est totalement gratuite pour tous les utilisateurs (y compris avec le plan Gratuit). Vous retrouverez le livre directement dans la barre de navigation de votre tableau de bord.",

    "help.contact.title": "Vous ne trouvez pas votre réponse ?",
    "help.contact.desc": "Notre équipe de support est là pour vous aider du lundi au vendredi.",
    "help.contact.cta": "Contacter le support"
};
